"use strict";
/*
 * Created on 14.10.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");

var WindowSearchFilter_1 = require("../../window/model/WindowSearchFilter");
/**
 * @author Tomáš Leity
 * @author Radek Beran
 */


var WindowPerformanceReportFilter =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowPerformanceReportFilter, _DomainObject_1$Domai);

  /**
   * @param includeSimulations
   * @param includeRejectedWindows
   * @param years
   * @param weeks
   * @param search
   * @param levels
   * @param promotionWeekType
   * @param promotionSelect
   * @param storeSpecifications
   * @param windowStates
   * @param windowTypeIds
   * @param windowThemeIds
   */
  function WindowPerformanceReportFilter( // Checkbox selection
  includeSimulations, includeRejectedWindows, // Common
  years, weeks, search, levels, // Promotion
  promotionWeekType, promotionSelect, storeSpecifications, // Window
  windowStates, windowTypeIds, windowThemeIds) {
    var _this;

    _classCallCheck(this, WindowPerformanceReportFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowPerformanceReportFilter).call(this));
    _this.includeSimulations = includeSimulations;
    _this.includeRejectedWindows = includeRejectedWindows;
    _this.years = years;
    _this.weeks = weeks;
    _this.search = search;
    _this.levels = levels;
    _this.promotionWeekType = promotionWeekType;
    _this.promotionSelect = promotionSelect;
    _this.storeSpecifications = storeSpecifications;
    _this.windowStates = windowStates;
    _this.windowTypeIds = windowTypeIds;
    _this.windowThemeIds = windowThemeIds;
    return _this;
  }

  _createClass(WindowPerformanceReportFilter, [{
    key: "toWindowSearchFilter",
    value: function toWindowSearchFilter(portfolios) {
      return new WindowSearchFilter_1.WindowSearchFilter(this.years, this.weeks, this.search, portfolios, this.promotionWeekType, this.promotionSelect, this.storeSpecifications, this.windowStates, this.windowTypeIds, this.windowThemeIds);
    }
  }, {
    key: "isIncludeRejectedOff",
    value: function isIncludeRejectedOff() {
      return !utils_1.Utils.isBool(this.includeRejectedWindows) || !this.includeRejectedWindows;
    }
  }, {
    key: "isIncludeSimulationsOn",
    value: function isIncludeSimulationsOn() {
      return utils_1.Utils.isBool(this.includeSimulations) && this.includeSimulations;
    }
  }]);

  return WindowPerformanceReportFilter;
}(DomainObject_1.DomainObject);

exports.WindowPerformanceReportFilter = WindowPerformanceReportFilter;
WindowPerformanceReportFilter.EMPTY = new WindowPerformanceReportFilter();